import React from "react";
import { GIF } from "../../asset";

export default function UnderDev() {
  return (
    <div className="h-full flex flex-col justify-center items-center ">
      <img src={GIF.under_dev} alt="dev gif" />
      <p className="text-xl font-semibold text-primary">
        Page Under Development
      </p>
    </div>
  );
}
